const URL = process.env.REACT_BASE_URL

console.log("URL", URL)

export const baseUrl = {
    LOGIN_API: URL + "/login",
    DATA_API: URL + "/getAll",
}

